import React from 'react'

const AdminUsers: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Admin Users</h1>
      <p className="text-gray-600 mt-2">Manage users here.</p>
    </div>
  )
}

export default AdminUsers
